/**
 * Dialog snippet
 * 
 * @class Snippet_Dialog
 * @extends Snippet
 */

Snippet_Dialog = (function(Snippet) {

	var Snippet_Dialog = function() {
		this.construct.apply(this, arguments);
	};

	$.extend(true, Snippet_Dialog.prototype, Snippet.prototype, {
		/*
		 * Define moving among buttons default is circle moving
		 */
		circle: true,
		
		/**
		 * @inheritdoc Snippet#init
		 */
		init: function(parent, config) {
			this.circle = this.config.circle || true;
			
			this.on('show', this.onShow, this);
			this.on('hide', this.onHide, this);
			this.on('dialog.render', this.onDRender, this);
			this.on('dialog.destroy', this.onDDestroy, this);
		},
		/**
		 * @inheritdoc Snippet#create
		 */
		create: function() {
			if(App.dialog){
				App.dialog.silentDestroy();
			}
		
			var $wrapper = $(this.config.selector);
			if(!$wrapper.length){
				var cls = this.config.selector.replace('.', '');
				var $dialog = $('<div class="dialog" />');
				if($dialog.length){
					$dialog.empty();
				}
				
				$wrapper = $('<div class="wrapper ' + cls + '" />');
				$dialog.append($wrapper);
				$("body").append($dialog);
			}
			return $wrapper;
		},
		/**
		 * @inheritdoc Snippet#render
		 */
		render: function() {
			this.$el.empty();
			this.renderHeader();
			this.renderContent();
			this.renderButtons();
			App.dialog = this;
			this.trigger('dialog.render');
			this.show();
			this.focus();
		},
		/**
		 * Render header
		 * 
		 * @template
		 */
		renderHeader: function(){
		},

		/**
		 * Render content
		 * 
		 * @template
		 */
		renderContent: function(){
		},
		
		/**
		 * Render buttons
		 * 
		 * @template
		 */
		renderButtons: function(){
		},

		/**
		 * remove dialog without sending hide event
		 */
		silentDestroy: function(){
			this.trigger('dialog.destroy');
			this.isVisible = false;
			this.$el.hide();
			this.$el.parent().remove();
			
			this.event_stack = {};
			App.dialog = null;
		},
		
		/**
		 * @inheritdoc Snippet#destroy
		 */
		destroy: function() {
			this.trigger('dialog.destroy');
			this.hide();
			this.$el.parent().remove();
			
			this.event_stack = {};
			App.dialog = null;
		},
		/**
		 * Update right position of the dialog according to text content
		 */
		onShow: function(){
			var height = 0;
			var $title	 = this.$el.find('.title'),
				$content = this.$el.find('.content'),
				$version = this.$el.find('.version'),
				$buttons = this.$el.find('.buttons');
			
			height += parseInt($title.height(),10);
			height += parseInt($title.css('padding-top'),10);
			height += parseInt($title.css('padding-bottom'),10);
			height += parseInt($title.css('margin-top'),10);
			height += parseInt($title.css('margin-bottom'),10);

			height += parseInt($content.height(),10);
			height += parseInt($content.css('padding-top'),10);
			height += parseInt($content.css('padding-bottom'),10);
			height += parseInt($content.css('margin-top'),10);
			height += parseInt($content.css('margin-bottom'),10);

			height += parseInt($version.height(),10);
			height += parseInt($version.css('padding-top'),10);
			height += parseInt($version.css('padding-bottom'),10);
			height += parseInt($version.css('margin-top'),10);
			height += parseInt($version.css('margin-bottom'),10);

			height += parseInt($buttons.height(),10);
			height += parseInt($buttons.css('padding-top'),10);
			height += parseInt($buttons.css('padding-bottom'),10);
			height += parseInt($buttons.css('margin-top'),10);
			height += parseInt($buttons.css('margin-bottom'),10);
			
			this.$el.height(height);
			height = height + parseInt(this.$el.css('padding-top'),10) + parseInt(this.$el.css('padding-bottom'),10);
			
			var marginTop = Math.round(height*-0.5);
			this.$el.css('margin-top', marginTop);
		},

		/**
		 * Set focus to the current page
		 */
		onHide: function(){
			Router.activeScene.focus();
		},

		/**
		 * handling rendering dialog event
		 * 
		 * @template
		 */
		onDRender: function(){
		},

		/**
		 * handling destroying dialog event
		 * 
		 * @template
		 */
		onDDestroy: function(){
		},
		/**
		 * Calls onReturn() on focused element
		 * @inheritdoc Snippet#onReturn
		*/
		onReturn: function($el, event){
			this.destroy();
			Router.activeScene.focus();
		},
		/**
		 * @inheritdoc Snippet#onClick
		 */
		onClick: function($el, event) {
			 return this.onEnter.apply(this, arguments);
		},
		/**
		 * @inheritdoc Snippet#onEnter
		 */
		onEnter: function($el, event) {
			var action = $el.attr("data-action");
			this.trigger('action', action);

			return false;
		},
		/**
		 * @inheritdoc Snippet#navigate
		 */
		navigate: function(direction) {
			if (direction == "left") {
				return this.onLeft();
			}
			else if (direction == "right"){
				return this.onRight();
			}
			else if (direction == "up") {
				return this.onUp();
			}
			else if (direction == "down") {
				return this.onDown();
			}

			return false;
		},
		
		onUp: function() {
			this.trigger('leave:up');
			return false;
		},

		onDown: function() {
			this.trigger('leave:down');
			return false;
		},
		onLeft: function(){
			var $el = this.circle ? this.getCircleFocusable(-1) : this.getFocusable(-1, true);
			if($el.length){
				Focus.to($el);
			}
			else{
				this.trigger('leave:left');
			}
			return false;
		},

		onRight: function(){
			var $el = this.circle ? this.getCircleFocusable(1) : this.getFocusable(1, true);
			if($el.length){
				Focus.to($el);
			}
			else{
				this.trigger('leave:right');
			}
			return false;
		}
	});

	return Snippet_Dialog;

})(Snippet);


//////////////////
// WEBPACK FOOTER
// ./js/snippet/dialog.js
// module id = 67
// module chunks = 0